import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import AuthProvider, { useAuth } from "@/components/AuthProvider";
import { installAutoSync } from "@/lib/autoSync";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import TestProcessor from "@/pages/TestProcessor";
import Templates from "@/pages/Templates";
import TemplateBuilder from "@/pages/TemplateBuilder";
import Assets from "@/pages/Assets";
import StaffDirectory from "@/pages/StaffDirectory";
import Campaigns from "@/pages/Campaigns";
import BrandAssignment from "@/pages/BrandAssignment";
import Rules from "@/pages/Rules";
import AuditLog from "@/pages/AuditLog";
import SyncStatus from "@/pages/SyncStatus";
import Deploy from "@/pages/Deploy";
import ExchangeSetup from "@/pages/ExchangeSetup";
import HelpGuide from "@/pages/HelpGuide";
import RelayControl from "@/pages/RelayControl";
import Outbox from "@/pages/Outbox";
import DeliveryBypass from "@/pages/DeliveryBypass";
import DepartmentTemplates from "@/pages/DepartmentTemplates";
import Settings from "@/pages/Settings";
import "@/App.css";

// Install global auto-sync interceptor once at module load.
installAutoSync();

function ProtectedRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center font-body">
        <p className="text-sm text-[#5E5E5E]">Loading...</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/processor" element={<TestProcessor />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/builder" element={<TemplateBuilder />} />
        <Route path="/assets" element={<Assets />} />
        <Route path="/staff" element={<StaffDirectory />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/brands" element={<BrandAssignment />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/sync" element={<SyncStatus />} />
        <Route path="/deploy" element={<Deploy />} />
        <Route path="/exchange-setup" element={<ExchangeSetup />} />
        <Route path="/relay" element={<RelayControl />} />
        <Route path="/outbox" element={<Outbox />} />
        <Route path="/bypass" element={<DeliveryBypass />} />
        <Route path="/assignments" element={<DepartmentTemplates />} />
        <Route path="/help" element={<HelpGuide />} />
        <Route path="/audit-log" element={<AuditLog />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<ProtectedRoutes />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
